module.exports = __webpack_public_path__ + "img/grin-tongue-wink.8d7443bb.svg";